<template>
	<div class="xhorse-home">
		<x-header :path="$path"
				  :backColor="backColor"
				  :textColor="textColor"
				  :activeTopIndex="activeIndex.top"
				  :activeSideIndex="activeIndex.side"
				  :backVisible="backVisible"
				  @go="activeTo"></x-header>
		<slot></slot>
		<x-footer :path="$path"></x-footer>
		<x-home :backVisible="backVisible" :backStyle="backStyle"></x-home>
	</div>
</template>

<script>
    import xHeader from '@/components/zh-cn/header.vue'
    import xSide from '@/components/zh-cn/side.vue'
    import xMain from '@/components/zh-cn/main.vue'

    import banner from '@/assets/resource/images/home/banner_we_01.png'

    import coreLib from '@/lib/common'
    export default {
        components: {
            xHeader: xHeader,
            xSide: xSide,
            xMain: xMain,
            xFooter: () => import('@/components/zh-cn/footer'),
            xHome: () => import('@/components/zh-cn/home')
        },
        data: function () {
            return {
                textColor: '#2A2E2E',
                backColor: '#FFFFFF',
                source: {
                    banner: banner,
                },
                activeIndex: {
                    top: [],
                    side: []
                },
                isScrolled: false,
                activeClass: '',
                aboutBannerStyle: {},
                aboutSideStyle: {},
                aboutMainStyle: {},
                backVisible: false,
                backStyle: {
                    bottom: '3rem'
                }
            };
        },
        methods: {
            activeTo(params){
				/*console.log("Template[about]: ", params)*/
                const _this = this;
                var scrollPos = 0, sideVal = [];
                const componentInfo = _this.$RegistedName;
                const dateTime = (new Date()).getTime()
                if (params.type == 'top') {
                    _this.isScrolled = true;
                    var fullPath = params.val.map((item) => {
                        if (toString(item).indexOf('-')) {
                            return parseInt(item.toString().split('-').reverse()[0]);
                        } else {
                            return parseInt(item);
                        }
                    });
                    _this.activeIndex.top = fullPath;
                    _this.activeIndex.side = fullPath.slice(-1);
                    _this.$router.push({name: componentInfo[fullPath[0]].componentName, params: {date: dateTime}});
                    sideVal = _this.activeIndex.side;
                } else {
                    sideVal = params.val;
                    _this.activeIndex.side = sideVal;
                }
            },
            getMainPageHeight(activeInfo) {
                const _this = this;
                var activeTop = activeInfo.top;
                var activeSide = activeInfo.side;
                var assem = [activeTop[0], activeSide[0]];
                switch (assem.join(',')) {
                    case "1,1":
                        _this.activeClass = 'about-xhorse-class';
                        break;
                }
            },
            beforeRoute(){
                const _this = this;
                if (_this.$route.params) {
                    var parmas = _this.$route.params;
                    if (parmas.type == 'foot') {
                        _this.activeIndex = parmas;
                    }
                }
            },
            onAboutScroll(){
                const _this = this;
                _this.isScrolled = true;
                const aboutSide = _this.$refs.aboutSide;
                const aboutMainChild = _this.$refs.aboutMain.$children;
                const xheader = document.getElementById('x-header').getBoundingClientRect();
                const xfooter = document.getElementById('x-wrap-footer').getBoundingClientRect();
                const viewHeight = window.screen.availHeight;
                const viewWidth = window.screen.availWidth;
                try {
                    // 元素相对于浏览器的位置TOP
                    if (aboutSide.offsetTop >= 0) {
                        const SidePos = aboutSide.offsetTop;
                        //console.log("Menu[offsetTop]", SidePos)
                        // 元素相对于视窗的位置TOP
                        const SideClient = aboutSide.getBoundingClientRect();
                        const screenWh = document.body.clientWidth;
                        const viewWidth = window.screen.availWidth;
                        if (SideClient.top < 0) {
                            _this.aboutSideStyle = {
                                position: 'fixed',
                                height: '100%',
                                background: 'none',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0
                            };
                            const vLen = Number(aboutMainChild.length);
                            for (var vid = vLen - 1; vid >= 0; vid--) {

                                if (vid === 0) {
                                    _this.activeIndex.side = [1];
                                    break;
                                }
                                if (aboutMainChild[vid].$el.getBoundingClientRect().top > 0.75) {
                                    continue;
                                } else {
                                    _this.activeIndex.side = [vid + 1];
                                    break;
                                }

                            }
                        } else {
                            _this.aboutSideStyle.position = '';
                            _this.activeIndex.side = [1];
                        }
                    }
                    if ((xheader.top / 16) < _this.$visibleHomeTop) {
                        _this.backVisible = true;
                        if ((xfooter.top / 16) <= (viewHeight / 16)) {
                            const realBottomEm =
                            ((viewHeight - xfooter.top) / 16) < 30 ?
                            (30 + 0.8125 + 'rem') : (((viewHeight - xfooter.top) / 16) + 0.8125 + 'rem');
                            const realBottomPx = (viewHeight - xfooter.top) + 'px';
                            _this.backStyle.bottom = viewWidth > 1280 ? realBottomPx : realBottomEm;
                        } else {
                            _this.backStyle.bottom = '3rem';
                        }
                    } else {
                        _this.backVisible = false;
                    }
                } catch (err) {
                    //console.log(err)
                }

            }
        },
        watch: {
            activeIndex: {
                handler(activeInfo){
                    const _this = this;
                    _this.getMainPageHeight(activeInfo);
					/*console.log("监听：", activeInfo)*/
                },
                deep: true
            },
            $route: {
                handler: 'beforeRoute',
                deep: true
            },
            aboutSideStyle: {
                handler(val){
                    const _this = this;
                    const activeSide = _this.activeIndex.side;
                    if (parseInt(activeSide[0]) === 1) {
                        const aboutMainStyle = _this.aboutMainStyle;
                        _this.aboutMainStyle = {
                            position: 'relative',
							/*left: '0%'*/
                        };

                    } else {
                    }
                },
                deep: true
            }
        },
        mounted(){
            const _this = this;
            const isMobile = coreLib._isMobile();
            $("#x-header .h-li").css({color: '#2A2E2E'})
            // 监听滚动事件
            window.addEventListener('scroll', _this.onAboutScroll);
            var scrollPos = 0
            const activePath = _this.$store.state;
            //console.log("asssss",activePath)
            if (activePath.activeTop.length > 0 && activePath.activeSide.length > 0) {
                _this.activeIndex.top = activePath.activeTop;
                _this.activeIndex.side = activePath.activeSide;
                var sideVal = _this.activeIndex.side;
                _this.$nextTick(function () {
                    try {
                        // 根据菜单位置滚动
                        scrollPos = $(".about-xhorse:eq(" + parseInt(sideVal[0] - 1) + ")").offset().top;
                        window.scrollTo(0, parseInt(sideVal[0]) === 1 ? 0 : scrollPos);
                    } catch (e) {

                    }

                });
            } else {
                _this.activeIndex.top = [1, 1, 0];
                _this.activeIndex.side = [1];
            }
            // 动态设置banner的高度
            /*const screenWh = document.body.clientWidth;
            _this.aboutBannerStyle['minHeight'] = ((parseInt(screenWh) * 490) / 1920 / 16) + 'rem';*/
            // 动态设置side,main的宽度
            _this.aboutSideStyle = {};
            _this.aboutMainStyle = {};
        },
        created(){
            const _this = this;
            _this.beforeRoute();
        },
        destroyed() {
            const _this = this;
            window.removeEventListener('scroll', _this.onAboutScroll, false);
        },
        beforeRouteLeave (to, from, next) {
            //console.log("template[about]", to, from)
            const _this = this;
            var data = {
                side: _this.activeIndex.side,
                top: _this.activeIndex.top,
            };
            console.log(data)

            if (to.params.hasOwnProperty('activeTop') && to.params.hasOwnProperty('activeSide')) {
                data.side = to.params.activeSide;
                data.top = to.params.activeTop;
            }

            _this.$store.commit('setActivePath', {
                type: 'all',
                val: data
            });
            window.removeEventListener('scroll', _this.onAboutScroll, false);
            next(true)
        },
    }

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/page-components/index.vue